<template id="temp">
  <!-- vue实例外创建 -->
  <div>
    <el-container class="homeContainer">
      <el-header style="width: 100%; padding: 0px; height: auto">
        <div class="temptop">
          <!-- 左：折叠 + logo + 工作台 -->
          <div class="nav-left">
            <i
              class="el-icon-menu mobile-menu-btn"
              @click="showMobileNav = !showMobileNav"
            ></i>
            <i
              :class="!isNavOpen ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
              class="nav-collapse"
              @click="isNavOpen = !isNavOpen"
            ></i>
            <img class="nav-logo" src="../assets/logo.png" alt="亿信通" @click="gosecure()" />
            <span class="nav-sep-line"></span>
            <span class="nav-workspace" @click="$router.push('/secure')">
              <i class="el-icon-s-home" style="margin-right:3px"></i>工作台
            </span>
          </div>

          <!-- 中：搜索 -->
          <div class="relative flex-1 max-w-[560px]">
            <div
              class="flex items-center gap-2 px-4 h-[38px] rounded-xl border bg-white transition-all duration-200"
              :class="searchFocused ? 'search-gradient-border' : 'border-gray-200'"
            >
              <i class="el-icon-search flex-shrink-0 transition-colors" :class="searchFocused ? 'text-indigo-400' : 'text-gray-400'"></i>
              <input
                v-model="searchQuery"
                type="text"
                placeholder="搜索..."
                class="flex-1 bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400 min-w-0"
                @focus="onSearchFocus"
                @click="onSearchFocus"
                @blur="onSearchBlur"
              />
              <i
                v-if="searchQuery"
                class="el-icon-circle-close text-gray-300 text-sm cursor-pointer hover:text-gray-500 flex-shrink-0"
                @mousedown.prevent="searchQuery = ''"
              ></i>
            </div>

            <!-- 下拉面板 -->
            <div
              v-if="searchFocused"
              class="absolute top-[calc(100%+6px)] left-0 right-0 bg-white rounded-2xl shadow-2xl border border-gray-100 z-[9999] p-5"
              style="min-width: 420px"
            >
              <!-- 最近搜索 -->
              <template v-if="!searchQuery && recentSearches.length">
                <div class="flex items-center justify-between mb-2">
                  <span class="font-semibold text-gray-800 text-sm">最近搜索</span>
                  <span
                    class="text-xs text-gray-400 cursor-pointer hover:text-gray-600"
                    @mousedown.prevent="clearRecentSearches"
                  >清除</span>
                </div>
                <div class="flex flex-wrap gap-2 mb-5">
                  <span
                    v-for="item in recentSearches"
                    :key="item.route"
                    class="inline-flex items-center px-4 py-1.5 rounded-full bg-gray-100 text-sm text-gray-700 cursor-pointer hover:bg-gray-200 transition-colors"
                    @mousedown.prevent="navigateSearch(item.route, item.name)"
                  >{{ item.name }}</span>
                </div>
              </template>

              <!-- 猜你想搜 / 搜索结果 -->
              <div class="font-semibold text-gray-800 text-sm mb-3">
                {{ searchQuery ? '搜索结果' : '猜你想搜' }}
              </div>

              <template v-if="filteredSuggestions.length">
                <div v-for="cat in filteredSuggestions" :key="cat.category" class="mb-4 last:mb-0">
                  <div class="text-xs text-gray-400 mb-2">
                    {{ cat.category }}<span class="ml-1 text-gray-300">（{{ cat.items.length }}）</span>
                  </div>
                  <div class="flex flex-wrap gap-2">
                    <span
                      v-for="item in cat.items"
                      :key="item.route"
                      class="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 text-sm text-gray-600 bg-white cursor-pointer hover:border-indigo-300 hover:text-indigo-600 hover:bg-indigo-50 transition-all"
                      @mousedown.prevent="navigateSearch(item.route, item.name)"
                    >{{ item.name }}</span>
                  </div>
                </div>
              </template>

              <div v-else class="py-6 text-sm text-gray-400 text-center">
                没有找到「{{ searchQuery }}」相关内容
              </div>
            </div>
          </div>

          <!-- 右：AI大模型 + 快捷链接 + 用户 -->
          <div class="nav-right">
            <span class="ai-nav-item" @click="$router.push('/ai')">
              <img src="/ai-nav-deco.webp" class="ai-nav-img" alt="" />
              <span>大模型</span>
            </span>

            <template v-if="usersubtype != 1">
              <span class="nav-link" @click="shouye()">首页</span>
              <span class="nav-link" @click="gongdan()">工单</span>
              <span class="nav-link" @click="xiaoxi()">
                <i class="el-icon-bell"></i> 消息
              </span>
              <span class="nav-link" @click="feiyong()">费用</span>
            </template>

            <el-dropdown placement="bottom" @command="handleCommand">
              <div class="nav-user">
                <el-avatar :size="26" :src="touxiang" icon="el-icon-user"></el-avatar>
                <span class="nav-username">{{ submitId }}</span>
                <i class="el-icon-arrow-down nav-arrow"></i>
              </div>
              <el-dropdown-menu slot="dropdown" style="min-width:100px">
                <el-dropdown-item command="changePassword">个人主页</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>

      <!-- 移动端侧边导航 -->
      <div class="mobile-nav" :class="{ 'mobile-nav-show': showMobileNav }">
        <div class="mobile-nav-header">
          <span>菜单导航</span>
          <i class="el-icon-close" @click="showMobileNav = false"></i>
        </div>
        <el-menu
          :unique-opened="false"
          :default-active="activeSubMenuIndex"
          router
          class="mobile-menu"
          @select="handleMobileMenuSelect"
        >
          <!-- 复制原有导航结构 -->
          <el-submenu index="2" v-if="usersubtype != 1">
            <template slot="title">
              <i class="iconfont icon-chanpin el-icon2"></i>
              <span slot="title">产品与服务</span>
            </template>
            <el-menu-item-group>
              <span slot="title">产品</span>
              <el-menu-item index="/order"
                ><i class="iconfont icon-dinggou1"></i> 订购产品</el-menu-item
              >
            </el-menu-item-group>

            <el-menu-item-group>
              <span slot="title">物理服务器</span>
              <el-menu-item index="/independence"
                ><i class="iconfont icon-fuwuqi"></i> 独立服务器</el-menu-item
              >
              <el-menu-item index="/cabinet"
                ><i class="iconfont icon-jiguituoguan"></i>
                机柜/托管</el-menu-item
              >
              <!-- <el-menu-item index="/firewall">防火墙查询</el-menu-item> -->
            </el-menu-item-group>

            <el-menu-item-group>
              <span slot="title">云电脑</span>
              <el-menu-item index="/cloudPC"
                ><i class="iconfont icon-shishi"></i> 远程电脑</el-menu-item
              >
            </el-menu-item-group>

            <el-menu-item-group>
                <span slot="title">云服务器ECS</span>
                <el-menu-item index="/LightweightCloud"
                  ><i class="iconfont icon-shishi"></i> 轻量云</el-menu-item
                >
                <el-menu-item index="/graphicsCloud"
                ><i class="iconfont icon-shishi"></i> 显卡云</el-menu-item
                >
                <el-menu-item index="/blockStorage"
                  ><i class="iconfont icon-ETL-guanlian"></i> 块存储</el-menu-item
                >
                <el-menu-item index="/server"
                  ><i class="iconfont icon-yunfuwuqi"></i> 传统云</el-menu-item
                >
              </el-menu-item-group>

              <el-menu-item-group>
                <span slot="title">人工智能</span>
                <el-menu-item index="/ai"
                  ><i class="iconfont icon-cpu"></i> AI大模型</el-menu-item
                >
              </el-menu-item-group>

            <el-menu-item-group>
              <span slot="title">全网加速</span>
              <el-menu-item index="/applicationAccelerate"
                ><i class="iconfont icon-anquan1"></i>
                应用加速</el-menu-item
              >
            </el-menu-item-group>

            <el-menu-item-group>
              <span slot="title">所有产品</span>
              <el-menu-item index="/otherProduct"
                ><i class="iconfont icon-tubiaozhizuomoban"></i>
                所有产品</el-menu-item
              >
            </el-menu-item-group>

            <!-- <el-menu-item-group>
              <span slot="title">模型平台</span>
              <el-menu-item index="/model"
                ><i class="iconfont icon-cpu"></i>
                模型服务平台</el-menu-item
              >
            </el-menu-item-group> -->

            <!-- <el-menu-item-group>
              <span slot="title">游戏加速</span>

              <el-menu-item index="/yyjs"
                ><i class="iconfont icon-anquan1"></i>
                应用加速(高防)</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group>
              <span slot="title">网站加速</span>
              <el-menu-item index="/Ycdn"
                ><i class="iconfont icon-ETL-guanlian"></i>
                边缘加速(YCDN)</el-menu-item
              >
            </el-menu-item-group> -->
          </el-submenu>
          <el-submenu index="3" v-if="usersubtype != 1">
            <template slot="title">
              <i class="iconfont icon-zhanghuyue el-icon2"></i>
              <span slot="title">财务管理</span>
            </template>
            <el-menu-item-group>
              <span slot="title">财务</span>
              <el-menu-item index="/billList">
                <i class="iconfont icon-wodezhangdan"></i>
                账单列表</el-menu-item
              >
              <el-menu-item index="/record"
                ><i class="iconfont icon-jiaoyi"></i> 交易记录</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group>
              <span slot="title">流量费用</span>
              <el-menu-item index="/trafficBillList">
                <i class="iconfont icon-wodezhangdan"></i>
                账单列表</el-menu-item
              >
              <el-menu-item index="/trafficRecord"
                ><i class="iconfont icon-jiaoyi"></i> 扣费记录</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group>
              <span slot="title">大模型</span>
              <el-menu-item index="/modelRecord"
                ><i class="iconfont icon-jiaoyi"></i> 费用记录</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group>
              <span slot="title">充值</span>
              <el-menu-item index="/recharge"
                ><i class="iconfont icon-caiwu"></i> 账户充值</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4" v-if="usersubtype != 1">
            <template slot="title">
              <i class="iconfont icon-yonghu el-icon2"></i>
              <span slot="title">账户管理</span>
            </template>
            <el-menu-item-group>
              <span slot="title">个人</span>
              <el-menu-item index="/authentication"
                ><i class="iconfont icon-shiming"></i> 实名认证</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group>
              <span slot="title">其他</span>
              <el-menu-item index="/work"
                ><i class="iconfont icon-gongdan"></i> 工单列表</el-menu-item
              >
              <el-menu-item index="/messageList"
                ><i class="iconfont icon-xiaoxi"></i> 消息列表</el-menu-item
              >
              <el-menu-item index="/coupon"
                ><i class="iconfont icon-youhuijuan"></i> 优惠卷</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="5">
            <template slot="title">
              <i class="iconfont icon-anquan1 el-icon2"></i>
              <span slot="title"> 流量防护</span>
            </template>
            <el-menu-item-group>
              <span slot="title">DDoS服务</span>
              <el-menu-item index="/firewall">
                <i class="iconfont icon-fanghuoqiang el-icon2"></i>
                <span slot="title">防火墙查询</span>
              </el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <span slot="title">安全检查</span>
              <el-menu-item index="/securityOverview">
                <i class="iconfont icon-weixiejiance1 el-icon2"></i>
                漏洞提醒</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="6">
            <template slot="title">
              <i class="el-icon-document el-icon2"></i>
              <span slot="title"> 安全审计</span>
            </template>
            <el-menu-item-group>
              <span slot="title">域名备案</span>
              <el-menu-item index="/whiteList">
                <i
                  style="width: 24px; display: inline-block"
                  class="iconfont icon-baimingdan1-copy el-icon2"
                ></i>
                <span slot="title">域名白名单</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="7">
            <template slot="title">
              <i class="el-icon-connection el-icon2"></i>
              <span slot="title"> 对外接口</span>
            </template>
            <el-menu-item-group>
              <span slot="title">财务系统API</span>
              <el-menu-item index="/createAppid">
                <i
                  style="width: 24px; display: inline-block;font-size:20px"
                  class="el-icon-folder-add"
                ></i>
                <span slot="title">对接API设置</span>
              </el-menu-item>
              <el-menu-item index="/openDocument">
                <i
                  style="width: 24px; display: inline-block;font-size:20px"
                  class="el-icon-document"
                ></i>
                <span slot="title">开放文档</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>

      <!-- 遮罩层 - 移动端导航显示时出现 -->
      <div
        class="mobile-mask"
        v-if="showMobileNav"
        @click="showMobileNav = false"
      ></div>

      <el-container >
        <!-- 可以给el-aside加style="height: 100vh" -->
        <el-aside
          v-if="$route.path !== '/model'"
          :width="isNavOpen ? '64px' : '200px'"
          style="height: 100%"
          class="desktop-aside"
        >
          <!-- <button class="nav-toggle" @click="toggleNav">{{ isNavOpen ? '隐藏导航' : '显示导航' }}</button> -->
          <el-menu
            :unique-opened="false"
            :default-active="activeSubMenuIndex"
            :collapse="isNavOpen"
            :router="true"
            @updateActiveItem="handleUpdateActiveItem"
            class="pcelmenu"
          >
            <el-submenu index="2" v-if="usersubtype != 1">
              <template slot="title">
                <i class="iconfont icon-chanpin el-icon2"></i>
                <span slot="title">产品与服务</span>
              </template>
              <el-menu-item-group>
                <span slot="title">产品</span>
                <el-menu-item index="/order"
                  ><i class="iconfont icon-dinggou1"></i> 订购产品</el-menu-item
                >
              </el-menu-item-group>

              <el-menu-item-group>
                <span slot="title">物理服务器</span>

                <el-menu-item index="/independence"
                  ><i class="iconfont icon-fuwuqi"></i> 独立服务器</el-menu-item
                >
                <el-menu-item index="/cabinet"
                  ><i class="iconfont icon-jiguituoguan"></i>
                  机柜/托管</el-menu-item
                >
              </el-menu-item-group>

              <el-menu-item-group>
                <span slot="title">云电脑</span>
                <el-menu-item index="/cloudPC"
                  ><i class="iconfont icon-shishi"></i> 远程电脑</el-menu-item
                >
              </el-menu-item-group>

              <el-menu-item-group>
                <span slot="title">云服务器ECS</span>
                <el-menu-item index="/LightweightCloud"
                  ><i class="iconfont icon-shishi"></i> 轻量云</el-menu-item
                >
                <el-menu-item index="/graphicsCloud"
                ><i class="iconfont icon-xianqia"></i> 显卡云</el-menu-item
                >
                <el-menu-item index="/blockStorage"
                  ><i class="iconfont icon-ETL-guanlian"></i> 块存储</el-menu-item
                >
                <el-menu-item index="/server"
                  ><i class="iconfont icon-yunfuwuqi"></i> 传统云</el-menu-item
                >
              </el-menu-item-group>

              <el-menu-item-group>
                <span slot="title">人工智能</span>
                <el-menu-item index="/ai"
                  ><i class="iconfont icon-cpu"></i> AI大模型</el-menu-item
                >
              </el-menu-item-group>

              <el-menu-item-group>
                <span slot="title">全网加速</span>
                <el-menu-item index="/applicationAccelerate"
                  ><i class="iconfont icon-anquan1"></i>
                  应用加速</el-menu-item
                >
              </el-menu-item-group>

              <el-menu-item-group>
                <span slot="title">所有产品</span>
                <el-menu-item index="/otherProduct"
                  ><i class="iconfont icon-tubiaozhizuomoban"></i>
                  所有产品</el-menu-item
                >
              </el-menu-item-group>

              <!-- <el-menu-item-group>
                <span slot="title">模型平台</span>
                <el-menu-item index="/model"
                  ><i class="iconfont icon-cpu"></i>
                  模型服务平台</el-menu-item
                >
              </el-menu-item-group> -->

              <!-- <el-menu-item-group>
                <span slot="title">游戏加速</span>
                <el-menu-item index="/yyjs"
                  ><i class="iconfont icon-anquan1"></i>
                  应用加速(高防)</el-menu-item
                >
              </el-menu-item-group> -->
              <!-- <el-menu-item-group>
                <span slot="title">网站加速</span>
                <el-menu-item index="/Ycdn"
                  ><i class="iconfont icon-ETL-guanlian"></i>
                  边缘加速(YCDN)</el-menu-item
                >
              </el-menu-item-group> -->
            </el-submenu>
            <el-submenu index="3" v-if="usersubtype != 1">
              <template slot="title">
                <i class="iconfont icon-zhanghuyue el-icon2"></i>
                <span slot="title">财务管理</span>
              </template>
              <el-menu-item-group>
                <span slot="title">财务</span>
                <el-menu-item index="/billList">
                  <i class="iconfont icon-wodezhangdan"></i>
                  账单列表</el-menu-item
                >
                <el-menu-item index="/record"
                  ><i class="iconfont icon-jiaoyi"></i> 交易记录</el-menu-item
                >
              </el-menu-item-group>
              <el-menu-item-group>
                <span slot="title">流量费用</span>
                <el-menu-item index="/trafficBillList">
                  <i class="iconfont icon-wodezhangdan"></i>
                  账单列表</el-menu-item
                >
                <el-menu-item index="/trafficRecord"
                  ><i class="iconfont icon-jiaoyi"></i> 扣费记录</el-menu-item
                >
              </el-menu-item-group>
              <el-menu-item-group>
                <span slot="title">大模型</span>
                <el-menu-item index="/modelRecord"
                  ><i class="iconfont icon-jiaoyi"></i> 费用记录</el-menu-item
                >
              </el-menu-item-group>
              <el-menu-item-group>
                <span slot="title">充值</span>
                <el-menu-item index="/recharge"
                  ><i class="iconfont icon-caiwu"></i> 账户充值</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="4" v-if="usersubtype != 1">
              <template slot="title">
                <i class="iconfont icon-yonghu el-icon2"></i>
                <span slot="title">账户管理</span>
              </template>
              <el-menu-item-group>
                <span slot="title">个人</span>
                <el-menu-item index="/authentication"
                  ><i class="iconfont icon-shiming"></i> 实名认证</el-menu-item
                >
              </el-menu-item-group>
              <el-menu-item-group>
                <span slot="title">其他</span>
                <el-menu-item index="/work"
                  ><i class="iconfont icon-gongdan"></i> 工单列表</el-menu-item
                >
                <el-menu-item index="/messageList"
                  ><i class="iconfont icon-xiaoxi"></i> 消息列表</el-menu-item
                >
                <el-menu-item index="/coupon"
                  ><i class="iconfont icon-youhuijuan"></i> 优惠卷</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="5">
              <template slot="title">
                <i class="iconfont icon-anquan1 el-icon2"></i>
                <span slot="title"> 流量防护</span>
              </template>
              <el-menu-item-group>
                <span slot="title">DDoS服务</span>
                <el-menu-item index="/firewall">
                  <i class="iconfont icon-fanghuoqiang el-icon2"></i>
                  <span slot="title">防火墙查询</span>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <span slot="title">安全检查</span>
                <el-menu-item index="/securityOverview">
                  <i class="iconfont icon-weixiejiance1 el-icon2"></i>
                  漏洞提醒</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="6">
              <template slot="title">
                <i class="el-icon-document el-icon2"></i>
                <span slot="title"> 安全审计</span>
              </template>
              <el-menu-item-group>
                <span slot="title">域名备案</span>
                <el-menu-item index="/whiteList">
                  <i
                    style="width: 24px; display: inline-block"
                    class="iconfont icon-baimingdan1-copy el-icon2"
                  ></i>
                  <span slot="title">域名白名单</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="7">
              <template slot="title">
                <i class="el-icon-connection el-icon2"></i>
                <span slot="title"> 对外接口</span>
              </template>
              <el-menu-item-group>
                <span slot="title">财务系统API</span>
                <el-menu-item index="/createAppid">
                  <i
                    style="width: 24px; display: inline-block;font-size:20px"
                    class="el-icon-folder-add"
                  ></i>
                  <span slot="title">对接API设置</span>
                </el-menu-item>
                <el-menu-item index="/openDocument">
                  <i
                    style="width: 24px; display: inline-block;font-size:20px"
                    class="el-icon-document"
                  ></i>
                  <span slot="title">开放文档</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- <el-menu-item index="/inventory" v-if="usersubtype != 1">
                  <i class="iconfont icon-kucun el-icon2" ></i>
                  <span slot="title">硬件库存列表</span>
                </el-menu-item> -->
          </el-menu>
        </el-aside>

        <el-main style="background: #eff4fb; height: 95vh" class="content-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <div>
      <!-- <aiAssistant class="aizhushou"></aiAssistant> -->
    </div>
  </div>
</template>

<script>
import { GetunReadMessage } from "../api/user";
import Guanggao from "@/components/guanggao.vue";
import aiAssistant from "@/components/aiAssistant.vue";
export default {
  components: { Guanggao, aiAssistant },
  data() {
    return {
      activeSubMenuIndex: "/secure",
      submitId: null,
      unreadtotal: null,
      initialNum: 0,
      touxiang: require("@/assets/image/u=3061155316,329340046&fm=253&fmt=auto&app=138&f=JPEG.webp"),
      isNavOpen: false,
      usersubtype: null,
      isCollapse: false,
      showMobileNav: false,
      searchQuery: '',
      searchFocused: false,
      searchBlurTimer: null,
      recentSearches: JSON.parse(localStorage.getItem('yxt_recent_searches') || '[]'),
      navSuggestions: [
        {
          category: '控制台',
          items: [{ name: '工作台总览', route: '/secure' }],
        },
        {
          category: '产品与服务',
          items: [
            { name: '订购产品', route: '/order' },
            { name: 'AI大模型', route: '/ai' },
            { name: '轻量云', route: '/LightweightCloud' },
            { name: '显卡云', route: '/graphicsCloud' },
            { name: '块存储', route: '/blockStorage' },
            { name: '独立服务器', route: '/independence' },
            { name: '机柜/托管租用', route: '/cabinet' },
            { name: '传统云', route: '/server' },
            { name: '应用加速', route: '/applicationAccelerate' },
            { name: '所有产品', route: '/otherProduct' },
          ],
        },
        {
          category: '财务管理',
          items: [
            { name: '账单列表', route: '/billList' },
            { name: '交易记录', route: '/record' },
            { name: '费用记录', route: '/modelRecord' },
            { name: '账户充值', route: '/recharge' },
          ],
        },
        {
          category: '流量费用',
          items: [
            { name: '账单列表', route: '/trafficBillList' },
            { name: '扣费记录', route: '/trafficRecord' },
          ],
        },
        {
          category: '账户管理',
          items: [
            { name: '实名认证', route: '/authentication' },
            { name: '工单列表', route: '/work' },
            { name: '消息列表', route: '/messageList' },
            { name: '优惠券', route: '/coupon' },
          ],
        },
        {
          category: '增值服务',
          items: [
            { name: '漏洞提醒', route: '/securityOverview' },
            { name: '防火墙查询', route: '/firewall' },
            { name: '域名白名单', route: '/whiteList' },
            { name: 'API 设置', route: '/createAppid' },
            { name: '开放文档', route: '/openDocument' },
          ],
        },
      ],
    };
  },
  computed: {
    filteredSuggestions() {
      if (!this.searchQuery.trim()) return this.navSuggestions
      const q = this.searchQuery.trim().toLowerCase()
      return this.navSuggestions
        .map(cat => ({ ...cat, items: cat.items.filter(i => i.name.toLowerCase().includes(q)) }))
        .filter(cat => cat.items.length > 0)
    },
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      // this.activeSubMenuIndex = to.path;
      this.activeSubMenuIndex = to.meta.menuIndex || to.path;

      // console.log(to,from);
    },
  },
  created() {
    // this.activeSubMenuIndex = this.$route.path;
    console.log(this.$route);
    this.activeSubMenuIndex =
      this.$route.meta.menuIndex || this.$route.path || "/secure";

    // console.log(this.$route.path);
    // console.log(this.activeSubMenuIndex);
    let customusernametitle = JSON.parse(
      localStorage.getItem("customusernametitle")
    );
    this.submitId = customusernametitle;
    // console.log(this.submitId);
    this.getunreadmessage();
    let timer = setInterval(() => {
      // console.log(new Date());
      this.getunreadmessage();
    }, 10000);
    this.$once("hook:beforeDestroy", () => {
      // console.log("-----------------清除定时器");
      clearInterval(timer);
    });
    // this.checkCollapse();
    window.addEventListener("resize", this.checkCollapse);

    this.usersubtype = JSON.parse(localStorage.getItem("usersublogin"));
    console.log(this.usersubtype);
  },
  mounted() {
    this.checkWindowWidth();
    // 监听窗口大小变化事件
    window.addEventListener("resize", this.checkWindowWidth);
  },
  beforeDestroy() {
    // 移除窗口大小变化事件监听，防止内存泄漏
    window.removeEventListener("resize", this.checkWindowWidth);
  },
  methods: {
    onSearchFocus() {
      clearTimeout(this.searchBlurTimer)
      this.searchFocused = true
    },
    onSearchBlur() {
      this.searchBlurTimer = setTimeout(() => { this.searchFocused = false }, 150)
    },
    navigateSearch(route, name) {
      clearTimeout(this.searchBlurTimer)
      const recent = this.recentSearches.filter(r => r.name !== name)
      recent.unshift({ name, route })
      this.recentSearches = recent.slice(0, 12)
      localStorage.setItem('yxt_recent_searches', JSON.stringify(this.recentSearches))
      this.searchFocused = false
      this.searchQuery = ''
      if (this.$route.path !== route) this.$router.push(route)
    },
    clearRecentSearches() {
      this.recentSearches = []
      localStorage.removeItem('yxt_recent_searches')
    },
    handleMobileMenuSelect(index) {
      this.showMobileNav = false;
    },

    // 监听页面大小方法
    checkWindowWidth() {
      if (window.innerWidth < 1200) {
        this.isNavOpen = true;
      } else {
        this.isNavOpen = false;
      }
    },
    // menu
    handleUpdateActiveItem(index) {
      // console.log(index);
      this.activeItem = index;
    },
    logout() {
      this.$confirm("是否要退出登录", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.clear();
          this.$router.push("/login");
          this.$message({
            type: "success",
            message: "退出成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
          });
        });
    },
    // 个人主页或者退出登录
    handleCommand(command) {
      // 退出登录
      if (command === "logout") {
        this.logout();
        // 个人主页
      } else if (command === "changePassword") {
        // 处理个人主页的逻辑
        // 检查当前路径是否已经是 '/secure'
        if (this.$route.path !== "/secure") {
          this.$router.push("/secure");
        }
      }
    },

    // 点击首页跳转
    shouye() {
      // 检查当前路径是否已经是首页
      if (this.$route.path !== "/secure") {
        this.$router.push("/secure");
      }
    },
    // 点击消息跳转
    xiaoxi() {
      if (this.$route.path !== "/messageList") {
        this.$router.push("/messageList");
      }
    },
    // 点击费用跳转
    feiyong() {
      // 检查当前路径是否是费用
      if (this.$route.path !== "/recharge") {
        this.$router.push("/recharge");
      }
    },
    // 点击工单跳转
    gongdan() {
      // 检查当前路径是否是费用
      if (this.$route.path !== "/work") {
        this.$router.push("/work");
      }
    },
    // 点击图片跳转
    gosecure() {
      if (this.usersubtype == 1) {
        return;
      }
      if (this.$route.path !== "/secure") {
        this.$router.push("/secure");
      }
    },
    // 获取未读消息数据
    async getunreadmessage() {
      let data = await GetunReadMessage({
        belongUser: this.submitId,
        status: 0,
        hideLoading: true,
      });
      // console.log(data);
      // console.log(this.initialNum);
      if (data.code == 200) {
        this.unreadtotal = data.total;
        if (data.data[0]) {
          if (this.initialNum === 0) {
            this.initialNum = data.data[0].id;
          } else if (this.initialNum < data.data[0].id) {
            this.initialNum = data.data[0]?.id;
            // this.notifyMe1();
          }
        }
      }
    },

    // 弹窗方法
    notifyMe1() {
      if (!("Notification" in window)) {
        // 检查浏览器是否支持通知
        alert("当前浏览器不支持桌面通知");
      } else if (Notification.permission === "granted") {
        // 检查是否已授予通知权限；如果是的话，创建一个通知
        const notification = new Notification("你好！", {
          body: "\n您的需求已经处理完成,请查看",
          requireInteraction: true,
          silent: false,
        });
        notification.pageUrl = window.location.href;

        notification.onclick = function () {
          if (notification.pageUrl) {
            window.location.href = notification.pageUrl; // 跳转回原页面
          }
        };

        this.$refs.audio.currentTime = 0; //从头开始播放提示音
        this.$refs.audio.play(); //播放

        // …
      } else if (Notification.permission !== "denied") {
        // 我们需要征求用户的许可
        Notification.requestPermission().then((permission) => {
          // 如果用户接受，我们就创建一个通知
          if (permission === "granted") {
            const notification = new Notification("你好！");
            // …
          }
        });
      }

      // 最后，如果用户拒绝了通知，并且你想尊重用户的选择，则无需再打扰他们
    },
  },
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  /* width: 200px; */
  /* min-width: 200px; */
  /* min-height: 400px; */
  float: left;
}
.search-gradient-border {
  border-color: transparent !important;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(135deg, #818cf8, #60a5fa) border-box !important;
  box-shadow: 0 0 0 3px rgba(129,140,248,0.12);
}

/* ===== 阿里云风格导航 ===== */
.temptop {
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  box-shadow: 0 1px 4px rgba(0,21,41,0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

/* 左侧 */
.nav-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.nav-logo {
  height: 42px;
  display: block;
  cursor: pointer;
  flex-shrink: 0;
}
.nav-collapse {
  font-size: 18px;
  color: #555;
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s;
}
.nav-collapse:hover { color: #1677ff; }
.nav-sep-line {
  width: 1px;
  height: 16px;
  background: #ddd;
  flex-shrink: 0;
}
.nav-workspace {
  color: #444;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s;
}
.nav-workspace:hover { color: #1677ff; }


/* 右侧 */
.nav-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.nav-link {
  padding: 0 10px;
  height: 50px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s;
  border-bottom: 2px solid transparent;
  box-sizing: border-box;
}
.nav-link:hover {
  color: #1677ff;
  border-bottom-color: #1677ff;
}
.nav-user {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  height: 50px;
  cursor: pointer;
}
.nav-username {
  font-size: 13px;
  color: #333;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nav-arrow {
  font-size: 12px;
  color: #999;
}

/* AI 大模型入口 */
.ai-nav-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  height: 50px;
  text-decoration: none;
  color: #333;
  font-size: 13px;
  white-space: nowrap;
  flex-shrink: 0;
  border-bottom: 2px solid transparent;
  transition: color 0.2s, border-color 0.2s;
  box-sizing: border-box;
}
.ai-nav-item:hover {
  color: #1677ff;
  border-bottom-color: #1677ff;
}
.ai-nav-img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  pointer-events: none;
  flex-shrink: 0;
}

.el-submenu .el-menu-item {
  font-size: 13px;
  /* height: 35px; */
  /* margin: 12px 0; */
}
.el-submenu.is-active > .el-submenu__title {
  color: #409eff !important;
}

/* .indexright {
  float: left;
  width: 83%;
  padding: 15px 22px;
  min-width: 1200px;
} */

.boxmiddle {
  /* display: flex; */
  height: 100%;
}

.el-icon2 {
  vertical-align: middle;
  margin-right: 8px;
  width: 24px;
  text-align: center;
  font-size: 20px;
}

.my-class {
  display: block;
}

.toggle-button {
  position: absolute;
  top: 10px;
  right: 10px;
}

.my-class {
  display: block;
}

.yxtLogo {
  cursor: pointer;
}
.homeContainer {
  width: 100vw;
  height: 100vh;
  align-content: flex-start;
  background: var(--color-custom-bg);
  overflow: hidden;
  position: relative;
}
@media (max-width: 768px) {
  .nav-logo { display: none; }
  .nav-sep-line { display: none; }
  .nav-search { display: none; }
  .nav-link { display: none; }
  .nav-username { display: none; }
  .nav-collapse { display: none; }
  ::v-deep .el-menu--collapse {
    width: 99% !important;
  }
  .content-main {
    height: 100% !important;
  }
  .homeContainer {
    overflow: auto;
  }
}
@media (max-width: 1000px) {
  .homeContainer {
    overflow: auto;
  }
  .aizhushou {
    display: none;
  }
}
@media (max-width: 1600px) {
  .content-main {
    /* height: 100% !important; */
  }
}
@media (max-width: 10000px) {
  .content-main {
    /* height: 100% !important; */
  }
}

::v-deep .el-badge__content.is-fixed {
  position: absolute;
  top: 20px;
  right: 26px;
  transform: translateY(-50%) translateX(100%);
}

/* ===== 侧边栏整体 ===== */
::v-deep .el-aside {
  transition: width 0.3s ease;
  background: #fff;
  border-right: 1px solid #f0f2f5;
}
::v-deep .pcelmenu,
::v-deep .el-menu {
  border-right: none !important;
  background: #fff !important;
}

/* ===== 一级菜单标题（el-submenu） ===== */
::v-deep .el-submenu__title {
  height: 52px !important;
  line-height: 52px !important;
  padding: 0 14px 0 18px !important;
  margin: 3px 8px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #222 !important;
  transition: background 0.15s, color 0.15s;
}
::v-deep .el-submenu__title:hover {
  background: #f0f2f7 !important;
  color: #222 !important;
}
::v-deep .el-submenu__title i {
  color: #777 !important;
  font-size: 20px;
  margin-right: 12px;
  vertical-align: middle;
  display: inline-block;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}
/* 展开/激活的一级菜单 — 不单独高亮，保持普通展开状态 */
::v-deep .el-submenu.is-active > .el-submenu__title,
::v-deep .el-submenu.is-active.is-opened > .el-submenu__title {
  color: #222 !important;
  background: transparent !important;
  font-weight: 500;
}
::v-deep .el-submenu.is-active > .el-submenu__title i,
::v-deep .el-submenu.is-active.is-opened > .el-submenu__title i {
  color: #777 !important;
}

/* ===== 分组标题 ===== */
::v-deep .el-menu-item-group__title {
  padding: 8px 16px 3px 20px;
  font-size: 11px;
  color: #888;
  font-weight: 500;
  letter-spacing: 0.03em;
}

/* ===== 子菜单项 ===== */
::v-deep .el-menu-item-group .el-menu-item,
::v-deep .el-menu--inline .el-menu-item {
  height: 36px !important;
  line-height: 36px !important;
  padding-left: 40px !important;
  margin: 1px 8px;
  border-radius: 6px;
  font-size: 14px;
  color: #555 !important;
  border-right: none !important;
  transition: background 0.15s, color 0.15s;
}
/* 子项图标 */
::v-deep .el-menu-item-group .el-menu-item i,
::v-deep .el-menu--inline .el-menu-item i {
  font-size: 15px;
  color: #aaa;
  margin-right: 8px;
  flex-shrink: 0;
  transition: color 0.15s;
}
::v-deep .el-menu-item:hover i {
  color: #666 !important;
}
::v-deep .el-menu-item.is-active i {
  color: #2c5ff6 !important;
}
::v-deep .el-menu-item:hover {
  background: #f0f2f7 !important;
  color: #111 !important;
}
::v-deep .el-menu-item.is-active {
  background: #e8effe !important;
  color: #2c5ff6 !important;
  font-weight: 600;
}

::v-deep .el-menu--collapse {
  width: 99%;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  color: #333;
  font-size: 24px;
  cursor: pointer;
  flex-shrink: 0;
  padding: 4px;
  transition: color 0.2s;
}

.mobile-menu-btn:hover {
  color: #155dfc;
}

.mobile-menu-btn:active {
  transform: scale(0.95);
}

/* 移动端导航样式 */
.mobile-nav {
  position: fixed;
  top: 0;
  left: -280px;
  width: 280px;
  height: 100vh;
  background: white;
  z-index: 3001;
  transition: left 0.3s ease;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.mobile-nav-show {
  left: 0;
}

.mobile-nav-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.mobile-nav-header .el-icon-close {
  font-size: 20px;
  cursor: pointer;
}

.mobile-menu {
  height: calc(100% - 50px);
  overflow-y: auto;
}

/* 遮罩层样式 */
.mobile-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}


.pcelmenu{
  height: 100%;
  overflow: auto;
  padding-top: 10px;
}
.pcelmenu::-webkit-scrollbar {
    width: 0px; /* 滚动条宽度 */
    height: 0px;
  }
  
 .pcelmenu::-webkit-scrollbar-track {
    background: #f1f1f1; /* 滚动槽 */
  }
  
 .pcelmenu::-webkit-scrollbar-thumb {
    background: #dddddd; /* 滚动条 */
    border-radius: 10px;
  }
  
 .pcelmenu::-webkit-scrollbar-thumb:hover {
    background: #555; /* 滚动条悬停时的样式 */
  }
  
/* 媒体查询 - 移动端适配 */
@media (max-width: 768px) {
  /* 显示移动端菜单按钮 */
  .mobile-menu-btn {
    display: inline-block !important;
  }

  /* 隐藏PC端控制按钮 */
  .pc-nav-controls {
    display: none !important;
  }

  /* 隐藏桌面端侧边栏 */
  .desktop-aside {
    display: none !important;
  }

  /* 调整logo容器 */
  .yxtlogodiv {
    position: relative;
    justify-content: flex-end;
  }

  /* 顶部导航条适配 */
  .temptop {
    min-width: auto;
    padding: 10px 12px;
    flex-wrap: nowrap;
    gap: 8px;
  }

  /* 左侧区域 */
  .nav-left {
    flex-shrink: 0;
    gap: 8px;
    padding-left: 0;
  }

  /* 隐藏折叠按钮（PC端专用） */
  .nav-collapse {
    display: none !important;
  }

  /* Logo缩小 */
  .nav-logo {
    height: 28px !important;
    width: auto;
  }

  /* 隐藏分隔线 */
  .nav-sep-line {
    display: none !important;
  }

  /* 隐藏工作台 */
  .nav-workspace {
    display: none !important;
  }

  /* 搜索框适配 */
  .nav-left + div {
    max-width: none !important;
    flex: 1;
    min-width: 0;
  }

  /* 搜索框缩小 */
  .nav-left + div > div {
    height: 36px !important;
    padding: 0 10px !important;
  }

  /* 搜索框输入 */
  .nav-left + div input {
    font-size: 13px !important;
  }

  /* 搜索下拉面板适配 */
  .nav-left + div .absolute {
    left: -12px !important;
    right: -12px !important;
    min-width: auto !important;
    width: calc(100vw - 24px) !important;
  }

  /* 右侧区域 */
  .nav-right {
    flex-shrink: 0;
    gap: 6px;
    padding-right: 0;
  }

  /* 隐藏AI大模型和快捷链接（移到侧边栏） */
  .ai-nav-item,
  .nav-link {
    display: none !important;
  }

  /* 用户头像区域缩小 */
  .nav-user {
    padding: 4px 8px !important;
  }

  .nav-username {
    display: none !important;
  }

  .nav-arrow {
    display: none !important;
  }

  /* 内容区域适配 */
  .content-main {
    padding: 12px !important;
    margin: 0 !important;
  }

  /* 移动端导航抽屉优化 */
  .mobile-nav {
    width: 85vw;
    max-width: 320px;
    left: -100%;
  }

  .mobile-nav-show {
    left: 0;
  }

  .mobile-nav-header {
    padding: 16px;
    font-size: 16px;
    font-weight: 600;
  }

  .mobile-menu {
    height: calc(100vh - 56px);
    padding-bottom: 20px;
  }

  /* 移动端菜单样式优化 */
  .mobile-menu ::v-deep .el-submenu__title {
    height: 48px !important;
    line-height: 48px !important;
    font-size: 14px;
  }

  .mobile-menu ::v-deep .el-menu-item {
    height: 44px !important;
    line-height: 44px !important;
    font-size: 14px;
  }

  .mobile-menu ::v-deep .el-menu-item-group__title {
    font-size: 11px;
    padding: 10px 16px 6px;
  }

  /* 遮罩层 */
  .mobile-mask {
    z-index: 3000;
  }
}

/* 中等屏幕适配（平板） */
@media (max-width: 1024px) and (min-width: 769px) {
  .temptop {
    padding: 12px 16px;
  }

  .nav-left {
    gap: 10px;
  }

  .nav-logo {
    height: 32px;
  }

  .nav-workspace {
    font-size: 14px;
  }

  .nav-link {
    font-size: 13px;
    padding: 6px 10px;
  }

  .ai-nav-item {
    font-size: 13px;
    padding: 6px 10px;
  }

  .nav-username {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
::v-deep .desktop-aside {
  height: calc(100vh - 50px) !important; /* 减去顶部导航栏高度 */
}
</style>
